import { render, staticRenderFns } from "./AboutPopup.vue?vue&type=template&id=b1e01a04&scoped=true&"
import script from "./AboutPopup.vue?vue&type=script&lang=js&"
export * from "./AboutPopup.vue?vue&type=script&lang=js&"
import style0 from "./AboutPopup.vue?vue&type=style&index=0&id=b1e01a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e01a04",
  null
  
)

export default component.exports